"use client";

import { RiArrowRightSLine, RiChatSmile3Line } from "react-icons/ri";
import { useChatLauncher } from "@/modules/chat";

/**
 * Linha "pergunte ao assistente" da busca: leva o termo digitado direto para o
 * chat do site (abre o painel já enviando a mensagem). `onActivate` deixa o
 * chamador fechar a própria casca (modal/dropdown) antes de abrir o chat.
 *
 * Layout de linha única: texto + termo numa frase só, com truncate — encolhe
 * até larguras estreitas (dropdown desktop e modal mobile) sem quebrar altura.
 */
export function SearchChatCta({ term, onActivate }: { term: string; onActivate?: () => void }) {
    const openChatWith = useChatLauncher((s) => s.openChatWith);

    return (
        // Wrapper com o respiro + `w-full` no botão: <button> tem width
        // fit-content por padrão (não estica como div) — sem isso a pílula
        // abraça o texto no dropdown desktop (pai block) em vez de ocupar a
        // linha; no modal (pai flex-col) o stretch mascarava o problema.
        <div className="px-3 py-2">
            <button
                type="button"
                onClick={() => {
                    onActivate?.();
                    openChatWith(term);
                }}
                className="group flex w-full min-w-0 items-center gap-2 rounded-lg border border-primary bg-base-100 px-3 py-2.5 text-left transition-colors hover:bg-primary/5"
            >
                <RiChatSmile3Line className="size-4 shrink-0 text-primary" aria-hidden="true" />
                <span className="min-w-0 flex-1 truncate text-sm text-base-content">
                    <span className="font-semibold">Pergunte ao assistente</span>
                    <span className="text-base-content/60"> — “{term}”</span>
                </span>
                <RiArrowRightSLine
                    className="size-4 shrink-0 text-primary transition-transform group-hover:translate-x-0.5"
                    aria-hidden="true"
                />
            </button>
        </div>
    );
}
